import React from 'react';
import PropTypes from 'prop-types';

function HashfileCard({
  hashfile, uploadHashfile, hashfileCase, setHashfileCase,
}) {
  const uploadFileLabel = hashfile ? hashfile.name : 'Choose File';
  return (
    <div className="card border-primary">
      <h4 className="p-3 bg-primary text-white">Hashfile</h4>
      <div className="card-body">
        <h4>Hashfile CSV</h4>
        <div className="custom-file">
          <input
            type="file"
            className="custom-file-input"
            id="compareHashfile"
            onChange={uploadHashfile}
          />
          <label className="custom-file-label" htmlFor="compareHashfile">
            {uploadFileLabel}
          </label>
          <small className="form-text text-muted">
            The file must be a csv file and have one column that contains MD5 hashed emails.
          </small>
          <h5 className="mt-3">Case of Hashfile</h5>
          <div className="custom-control custom-radio custom-control-inline">
            <input
              type="radio"
              id="compareUpperHashfile"
              name="compareHashfileCase"
              className="custom-control-input"
              value="upper"
              checked={hashfileCase === 'upper'}
              onChange={setHashfileCase}
            />
            <label className="custom-control-label" htmlFor="compareUpperHashfile">
              Upper
            </label>
          </div>
          <div className="custom-control custom-radio custom-control-inline">
            <input
              type="radio"
              id="compareLowerHashfile"
              name="compareHashfileCase"
              className="custom-control-input"
              value="lower"
              checked={hashfileCase === 'lower'}
              onChange={setHashfileCase}
            />
            <label className="custom-control-label" htmlFor="compareLowerHashfile">
              Lower
            </label>
          </div>
        </div>
      </div>
    </div>
  );
}

HashfileCard.propTypes = {
  hashfile: PropTypes.instanceOf(File),
  hashfileCase: PropTypes.string.isRequired,
  uploadHashfile: PropTypes.func.isRequired,
  setHashfileCase: PropTypes.func.isRequired,
};

HashfileCard.defaultProps = {
  hashfile: null,
};

export default HashfileCard;
